import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { PrintCompanyInfoResource } from '@blcloud/bl-ng-resource';
import { CompanyNameSelectGuideComponent } from './company-name-select-guide.component';


@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule
  ],
  declarations: [
    CompanyNameSelectGuideComponent
  ],
  entryComponents: [
    CompanyNameSelectGuideComponent
  ],
  exports: [
    CompanyNameSelectGuideComponent
  ],
  providers: [
    PrintCompanyInfoResource,
  ]
})
export class CompanyNameSelectGuideModule { }



// WEBPACK FOOTER //
// ./src/app/feature/slip-print-detail-setting/tab/slip-print-detail-setting-for-header/company-name-select-guide/company-name-select-guide.module.ts